var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"socials"},[_c('div',{staticClass:"a-container"},[_c('h2',{staticClass:"title"},[_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")]),_vm._v(" "),(_vm.lead)?_c('div',{staticClass:"lead"},[_vm._v("\n            "+_vm._s(_vm.lead)+"\n        ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }